import React, { useContext, useState, useEffect } from "react";
import { db, auth, storageRef, arrayUnion } from "../firebase";
// import { arrayUnion } from "firebase/firestore";
import firebase from "firebase";
import ProductService from "../service/ProductService";
import { resolve } from "dns";
import Text from "../constants/Text";
const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(); // login auth
  const [user, setUser] = useState(); // firestore

  function signup(email, password) {
    return auth
      .createUserWithEmailAndPassword(email, password)
      .then(async (cred) => {
        console.log(`cred: ${JSON.stringify(cred)}`);
        await db
          .collection("supportersCount")
          .doc(cred.user.uid)
          .set({ supportersCount: 0 });
        return db
          .collection("admin")
          .doc(cred.user.uid)
          .set({
            bio: Text.DEFAULT_BIO,
            username: Text.DEFAULT_USERNAME,
            photoUrl: "",
            links: [],
            uid: cred.user.uid,
          })
          .then(() => {
            console.log("Document successfully written");
          })
          .catch((error) => {
            console.error("Error writing document: ", error);
          });
      });
  }
  function login(email, password) {
    return new Promise((resolve, reject) => {
      resolve(auth.signInWithEmailAndPassword(email, password));
    });
  }

  async function getUser(uid) {
    const user = await db.collection("admin").doc(uid).get();
    const userData = user.data();
    console.log(`getUser:userData`, userData);
    let promises = [];
    userData.promotionIds.forEach((promoId) => {
      console.log("getUser:promtionId", promoId);
      promises.push(db.collection("promotions").doc(promoId).get());
    });

    // send request to get all promotions the user has an id for
    let promotionsArray = await Promise.all(promises);
    let usersPromotions = [];
    promotionsArray.forEach((promo) => {
      console.log("getUser:promo.data()", promo.data());
      usersPromotions.push(promo.data());
    });
    console.log(`getUser:db:user, ${JSON.stringify(user.data())}`);
    const supportersCount = await db
      .collection("supportersCount")
      .doc(uid)
      .get();
    console.log(
      `getUser:supporterCount, ${JSON.stringify(supportersCount.data())}`
    );
    setUser({
      ...user.data(),
      uid,
      ...supportersCount.data(),
      promotions: usersPromotions,
    });
    return;
  }
  async function getUserProducts(uid) {
    const user = await db.collection("admin").doc(uid).get();
    console.log(`getUser:db:user, ${JSON.stringify(user.data())}`);
    setUser({ ...user.data().links, uid });
    return;
  }
  function logout() {
    return auth.signOut();
  }
  function resetPassword(email) {
    console.log(`email ---------------- ${email}`);
    return auth.sendPasswordResetEmail(email);
  }

  function updateEmail(email) {
    return currentUser.updateEmail(email);
  }
  async function updateUsername(_username) {
    let newState = { ...user };
    newState.username = _username;
    setUser(newState);
    await db
      .collection("admin")
      .doc(currentUser.uid)
      .update({ username: _username });
  }
  async function updateBio(_bio) {
    let newState = { ...user };
    newState.bio = _bio;
    setUser(newState);
    await db.collection("admin").doc(currentUser.uid).update({ bio: _bio });
  }
  async function photoUploadBackend(file) {
    var metadata = {
      contentType: file.type,
    };
    console.log(`photoUploadBackend`);
    // Upload file and metadata to the object 'images/mountains.jpg'
    var uploadTask = storageRef
      .child("images/" + currentUser.uid)
      .put(file, metadata);

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log("Upload is paused");
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log("Upload is running");
            break;
        }
      },
      (error) => {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            break;
          case "storage/canceled":
            // User canceled the upload
            break;

          // ...
          case "storage/unknown":
            // Unknown error occurred, inspect error.serverResponse
            break;
        }
      },
      () => {
        // Upload completed successfully, now we can get the download URL
        // And update user database to use new url
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          console.log("File available at", downloadURL);
          const newuser = {
            bio: user.bio,
            links: user.links,
            photoUrl: downloadURL,
            username: user.username,
          };

          db.collection("admin").doc(currentUser.uid).update(newuser);
          console.log(`user: ${JSON.stringify(newuser)}`);
          setUser(newuser);
        });
      }
    );
  }
  async function editProductBackend(newProduct, OldProduct) {
    await deleteProductBackend(OldProduct);
    await db
      .collection("admin")
      .doc(currentUser.uid)
      .update({ links: firebase.firestore.FieldValue.arrayUnion(newProduct) });
  }
  /**
   * returns new promotion with new id
   * @param {*} promotion
   */
  async function addNewPromotion(promotion) {
    // add to promotion collection
    return new Promise((resolve) => {
      db.collection("promotions")
        .add(promotion)
        .then(async (docRef) => {
          console.log("addNewPromotion:docRef.id", docRef.id);
          const id = docRef.id;
          const newPromotion = { ...promotion, id, owner: currentUser.uid };
          console.log("addNewPromotion:newPromotion", newPromotion);
          db.collection("promotions").doc(id).update(newPromotion);

          // add to admin promotionIds
          db.collection("admin")
            .doc(currentUser.uid)
            .update({
              promotionIds: firebase.firestore.FieldValue.arrayUnion(id),
            });

          resolve(newPromotion);
        });
    });
  }
  /**
   * reponsible for adding new and editing products
   * @param {*} promotion
   * @returns promotion
   */
  async function editPromotionBackend(promotion) {
    console.log("editPromotionBackend:promotion", promotion);
    // new un referenced product
    /* 
        1. create the product and use firbase auto-generated id
        2. update the promotion with the new reference id
    */
    let newPromotion = {};
    // verified does vist this logic on new promotion creation
    if (!promotion.id) {
      console.log("editPromotionBackend:!promotion.id", promotion.id);
      newPromotion = await addNewPromotion(promotion);
      console.log(
        `editPromotionBackend:newPromotion:${JSON.stringify(newPromotion)}`
      );
      return newPromotion;
    } else {
      // existing referenced product
      /* 
          1. verify product exist
          2. update the promotion with the new reference id
    */
      db.collection("promotions")
        .doc(promotion.id)
        .update({ ...promotion });

      // docRef
      //   .get()
      //   .then(async (docRef) => {
      //     console.log(`promotion docRef`, docRef.data());
      //     // if (docRef.exist) {
      //     // need to verify collections are not lost
      //     newPromotion = { ...docRef.data(), ...promotion };
      //     docRef
      //       .update(newPromotion)
      //       .then((res) => {
      //         console.log(`editPromotionBackend:update:res`, res);
      //         return newPromotion;
      //       })
      //       .catch((e) => {
      //         console.log(
      //           `Unhadled failed response in editPromotionBackend`,
      //           e
      //         );
      //       });
      //     // }
      //     console.log("docRef.id", docRef.id);
      //     const id = docRef.id;
      //     newPromotion = { ...promotion, id };
      //     db.collection("promotions").doc(id).update(newPromotion);
      //     return newPromotion;
      //   })
      //   .catch((e) => {
      //     console.log(
      //       `unhandled promise rejection when calling update in editPromotionBackend `,
      //       e
      //     );
      //   });
    }
  }
  async function saveProductBackend(product) {
    await db
      .collection("admin")
      .doc(currentUser.uid)
      .update({
        links: firebase.firestore.FieldValue.arrayUnion(product),
      });

    // Currently we refetch user from backend
    // inefficient and needs to be optimized
    const user = await db.collection("admin").doc(currentUser.uid).get();
    setUser(user.data());
  }
  async function deletePromotionBackend(promotion) {
    /**
     * Delete the promotion from the collection
     */
    console.log(`deleteProductBackend:product, ${JSON.stringify(promotion)}`);
    var docRef = db.collection("promotions").doc(promotion.id);
    docRef.delete();

    /**
     * Delete the promotion from the user array of owned promotions
     */
    // grab user reference
    var linkRef = db.collection("admin").doc(currentUser.uid);
    linkRef.update({
      promotionIds: firebase.firestore.FieldValue.arrayRemove(promotion.id),
    });
  }
  async function deleteProductBackend(product) {
    console.log(`deleteProductBackend:product, ${JSON.stringify(product)}`);
    var linkRef = db.collection("admin").doc(currentUser.uid);
    // Atomically remove a region from the "regions" array field.
    linkRef.update({
      links: firebase.firestore.FieldValue.arrayRemove(product),
    });

    // Currently we refetch user from backend
    // inefficient and needs to be optimized
    const user = await db.collection("admin").doc(currentUser.uid).get();
    setUser(user.data());

    return;
  }
  async function deleteSelectedProductsBackend(products) {
    console.log(
      `deleteSelectedProductsBackend:selected products, ${JSON.stringify(
        products
      )}`
    );
    // Calls backend multiple times needs to be done with one request
    //  inefficient and needs to be optimized
    products.forEach((element) => {
      deleteProductBackend(element);
    });
    // Currently we refetch user from backend
    // inefficient and needs to be optimized
    const user = await db.collection("admin").doc(currentUser.uid).get();
    setUser(user.data());
  }
  async function deleteSelectedPromotionsBackend(promotions) {
    promotions.forEach((promo) => {
      deletePromotionBackend(promo);
    });
  }
  async function updateProductBackend(product) {
    console.log(`updateProductBackend:product, ${JSON.stringify(product)}`);

    await db
      .collection("admin")
      .doc(currentUser.uid)
      .update({
        links: firebase.firestore.FieldValue.arrayUpdate(product),
      });

    // Currently we refetch user from backend
    // inefficient and needs to be optimized
    const user = await db.collection("admin").doc(currentUser.uid).get();
    setUser(user.data());
  }

  function verifyEmail() {
    return auth.currentUser.sendEmailVerification();
  }
  function updatePassword(password) {
    return currentUser.updatePassword(password);
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      console.log(`useEffect:currentUser`, JSON.stringify(currentUser));
      setCurrentUser(currentUser);
    });
    return unsubscribe;
  }, []);

  const value = {
    getUser,
    getUserProducts,
    verifyEmail,
    currentUser,
    user,
    signup,
    login,
    logout,
    resetPassword,
    updatePassword,
    updateEmail,
    updateBio,
    updateUsername,
    saveProductBackend,
    deleteSelectedProductsBackend,
    deleteProductBackend,
    updateProductBackend,
    editProductBackend,
    photoUploadBackend,
    setCurrentUser,
    editPromotionBackend,
    deletePromotionBackend,
    deleteSelectedPromotionsBackend,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
